module.exports = __webpack_public_path__ + "img/banner3.0578a476.png";